import axios from '@/utils/api'

const actions = {

  async gerarDeclaracao ({ commit }, data) {
    await axios({
      method: 'post',
      url: 'declaracaoTramite/gerar',
      responseType: 'blob',
      data
    })
  },

  async getMotivos ({ commit }) {
    const result = await axios({
      method: 'get',
      url: 'declaracaoTramite/motivos'
    })

    return result
  }

}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/declaracaoTramite.js